import React, { Component } from 'react';
import Page from '../../../components/Page';
import { Segment, Header, Button, Input, Icon, Message, Confirm, Form, Table, Label } from 'semantic-ui-react';
import _ from 'lodash';
import { get, post } from '../../../util/api';
import MyMenu from '../menu';

// liveapi (x-api-key) anahtarı: maytap.product._token
// Sadece con_product.settings.developerApi açık hesaplarda görünür.
class DeveloperApi extends Component {
	state = {
		enabled: null,
		pid: '',
		token: '',
		base_url: '',
		loading: true,
		copied: '',
		show: false,
		confirmOpen: false,
		error: '',
		tags: [],
		selectedTag: null,
	};

	componentDidMount() {
		this.load();
		this.loadTags();
	}

	loadTags = async () => {
		try {
			const list = await post('/dahi/tag/list', {});
			const tags = (list.data && list.data.result && list.data.result.result) || [];
			this.setState({ tags: _.filter(tags, { active: true }) });
		} catch (e) {
			this.setState({ tags: [] });
		}
	};

	load = async () => {
		try {
			this.setState({ loading: true, error: '' });
			const res = await get('/live/product/developer-token');
			if (res.success) {
				const { enabled, pid, token, base_url } = res.data || {};
				this.setState({ enabled: !!enabled, pid: pid || '', token: token || '', base_url: base_url || '', loading: false });
			} else {
				this.setState({ error: res.message || 'Anahtar alınamadı.', loading: false });
			}
		} catch (e) {
			this.setState({ error: 'Anahtar alınamadı.', loading: false });
		}
	};

	regenerate = async () => {
		try {
			this.setState({ loading: true, confirmOpen: false, error: '' });
			const res = await post('/live/product/developer-token/regenerate', {});
			const data = res.data || res;
			if (data.success) {
				const { pid, token, base_url } = data.data || {};
				this.setState({ pid: pid || '', token: token || '', base_url: base_url || '', show: true, loading: false });
			} else {
				this.setState({ error: data.message || 'Üretim başarısız.', loading: false });
			}
		} catch (e) {
			this.setState({ error: 'Üretim başarısız.', loading: false });
		}
	};

	copy = (key, value) => () => {
		navigator.clipboard.writeText(value).then(() => {
			this.setState({ copied: key });
			setTimeout(() => this.setState({ copied: '' }), 2000);
		});
	};

	render() {
		const { enabled, pid, token, base_url, loading, copied, show, confirmOpen, error, tags, selectedTag } = this.state;
		const masked = token ? token.slice(0, 4) + '•'.repeat(Math.max(token.length - 8, 8)) + token.slice(-4) : '';
		const example = `curl -X POST "${base_url || 'BASE_URL'}/api/${pid || 'PID'}/callback/create" \\
  -H "x-api-key: ${token || 'TOKEN'}" \\
  -H "Content-Type: application/json" \\
  -d '{
    "phone": "0532 123 45 67",
    "name": "Ali",
    "email": "ali@example.com",
    "tag_id": "${selectedTag || 'TAG_ID'}"
  }'`;
		const params = [
			{ key: 'phone', required: true, desc: 'Telefon numarası' },
			{ key: 'name', required: false, desc: 'Müşteri adı' },
			{ key: 'email', required: false, desc: 'E-posta' },
			{ key: 'tag_id', required: false, desc: 'Yukarıdaki listeden seçilen etiket' },
		];

		return (
			<Page title="Developer API" icon="code" flex>
				<MyMenu activeItem="developer-api">
					<Page.Wrap>
						<Segment>
							<Header as="h3">
								<Icon name="code" />
								<Header.Content>
									Developer API
									<Header.Subheader>Live API servislerine erişim için hesap kimliği (pid) ve API anahtarı (x-api-key).</Header.Subheader>
								</Header.Content>
							</Header>

							{error && <Message negative content={error} />}

							{enabled === false && !loading && <Message warning content="Developer API bu hesapta açık değil." />}

							{enabled && (
								<Form style={{ marginTop: '16px' }}>
									<Form.Field>
										<label>Product ID (pid)</label>
										<Input value={pid} readOnly fluid style={{ fontFamily: 'monospace' }} action>
											<input />
											<Button icon={copied === 'pid' ? 'check' : 'copy'} color={copied === 'pid' ? 'green' : undefined} onClick={this.copy('pid', pid)} title="Kopyala" />
										</Input>
									</Form.Field>

									<Form.Field>
										<label>API Key (x-api-key)</label>
										<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
											<Input
												value={loading ? 'Yükleniyor...' : token ? (show ? token : masked) : 'Henüz üretilmedi'}
												readOnly
												fluid
												style={{ flex: 1, fontFamily: 'monospace' }}
												action
											>
												<input />
												<Button icon={show ? 'eye slash' : 'eye'} onClick={() => this.setState({ show: !show })} disabled={loading || !token} title="Göster / Gizle" />
												<Button
													icon={copied === 'token' ? 'check' : 'copy'}
													color={copied === 'token' ? 'green' : undefined}
													onClick={this.copy('token', token)}
													disabled={loading || !token}
													title="Kopyala"
												/>
											</Input>
											<Button
												icon={token ? 'refresh' : 'plus'}
												color={token ? 'orange' : 'green'}
												content={token ? 'Yenile' : 'Oluştur'}
												onClick={() => (token ? this.setState({ confirmOpen: true }) : this.regenerate())}
												disabled={loading}
											/>
										</div>
									</Form.Field>

									<Message info size="small">
										<Message.Content>Anahtar yenilenirse eski anahtarı kullanan tüm entegrasyonlar çalışmayı durdurur.</Message.Content>
									</Message>

									<Form.Field>
										<label>Etiketler (tag_id)</label>
										{tags.length ? (
											<Table compact size="small" selectable>
												<Table.Header>
													<Table.Row>
														<Table.HeaderCell>Etiket</Table.HeaderCell>
														<Table.HeaderCell>tag_id</Table.HeaderCell>
														<Table.HeaderCell width={2}></Table.HeaderCell>
													</Table.Row>
												</Table.Header>
												<Table.Body>
													{tags.map((it) => (
														<Table.Row key={it._id} active={selectedTag === it._id}>
															<Table.Cell>
																<Label circular empty style={{ backgroundColor: it.color, marginRight: '8px' }} />
																{it.title}
															</Table.Cell>
															<Table.Cell style={{ fontFamily: 'monospace' }}>{it._id}</Table.Cell>
															<Table.Cell textAlign="right">
																<Button
																	size="mini"
																	icon={copied === 'tag-' + it._id ? 'check' : 'copy'}
																	onClick={this.copy('tag-' + it._id, it._id)}
																	title="tag_id kopyala"
																/>
																<Button
																	size="mini"
																	primary={selectedTag === it._id}
																	content={selectedTag === it._id ? 'Seçili' : 'Seç'}
																	onClick={() => this.setState({ selectedTag: selectedTag === it._id ? null : it._id })}
																/>
															</Table.Cell>
														</Table.Row>
													))}
												</Table.Body>
											</Table>
										) : (
											<Message size="small" content="Aktif etiket bulunamadı." />
										)}
									</Form.Field>

									<Form.Field>
										<label>Örnek istek</label>
										<pre style={{ background: '#f5f5f5', padding: '12px', borderRadius: '4px', overflowX: 'auto', fontSize: '12px' }}>{example}</pre>
										<Button size="small" icon={copied === 'curl' ? 'check' : 'copy'} content="Kopyala" onClick={this.copy('curl', example)} disabled={!token} />
									</Form.Field>

									<Form.Field>
										<label>Parametreler</label>
										<Table compact size="small">
											<Table.Header>
												<Table.Row>
													<Table.HeaderCell>Alan</Table.HeaderCell>
													<Table.HeaderCell width={2}>Zorunlu</Table.HeaderCell>
													<Table.HeaderCell>Açıklama</Table.HeaderCell>
												</Table.Row>
											</Table.Header>
											<Table.Body>
												{params.map((it) => (
													<Table.Row key={it.key}>
														<Table.Cell style={{ fontFamily: 'monospace' }}>{it.key}</Table.Cell>
														<Table.Cell>
															{it.required ? <Label size="tiny" color="red" content="Zorunlu" /> : <Label size="tiny" content="Opsiyonel" />}
														</Table.Cell>
														<Table.Cell>{it.desc}</Table.Cell>
													</Table.Row>
												))}
											</Table.Body>
										</Table>
									</Form.Field>
								</Form>
							)}

							<Confirm
								open={confirmOpen}
								content="API anahtarı yenilenecek. Eski anahtarı kullanan entegrasyonlar çalışmayı durduracak. Devam etmek istiyor musunuz?"
								confirmButton="Evet, Yenile"
								cancelButton="İptal"
								onCancel={() => this.setState({ confirmOpen: false })}
								onConfirm={this.regenerate}
							/>
						</Segment>
					</Page.Wrap>
				</MyMenu>
			</Page>
		);
	}
}

export default DeveloperApi;
